import ReactDOM from 'react-dom';
import React from 'react';
import ArticlePaywall from './paywall-comp';
import ArticlePaywallTest from './goat-464-test/paywall-comp';

export interface CountrySelectorOption {
  value: string;
  text: string;
}

export interface Props {
  container_element: Element;
  get_paywall_data_url: string;
  translations: any;
  clg_paywall: boolean;
  article_id: number;
  current_country: string;
  should_show_geoblock: boolean;
  geo_country: string;
  country_selector_options: CountrySelectorOption[];
  top_publications: [];
  article_distributions: string[];
  article_paywall_copy_variation: string;
  clg_paywall_bullets_test_enabled?: boolean;
}

const init = async (props: Props) => {
  ReactDOM.render(
    <ArticlePaywallTest {...props} />,
    props.container_element,
  );
}

export const Paywall = {
  init,
};
